<template lang="pug">
  div#OurChurch
    v-container(  )
      v-img.float-sm-right.elevation-6( src="../../assets/img/5136483.jpg" width="50%" "min-width"="300" )
      v-row(justify="center")
        v-col(cols="12")
          
          .display-2 SUNDAY SERVICE
          v-card.float-sm-left.pa-2.elevation-6.mb-4.mr-2( color="info" width="400"    )
            p.title  Our worship service begins on Sunday,
              br 
              u.serviceTime {{getSunday}}
              |  at 
              u.serviceTime 11:00&nbsp;AM/PT
            p.title We gather as a congregation before service
              br
              | at 
              u.serviceTime 10:30&nbsp;AM/PT
          p.body-1.nowrap We are located in East Oakland right near the Oakland Colisuem. City of Refuge UCC is located directly off Interstate 880 and near Bay Area Rapid Transit (BART) and Amtrak so getting here has never&nbsp;been&nbsp;easier!
          p.body-1 Our church building is on the corner of Enterprise Way and Edes Avenue.
          p.body-1 Address: 8400 Enterprise Way, Oakland, CA 94621
      v-row(justify="center")
        v-col(cols="12")
          gMap
      v-row(justify="center")
        v-col(cols="12")
          v-card.pa-3(color="accent"  )
            .mb-4.display-1 Visitor's FAQs
            div.mb-4.faqText
              .title WHAT CAN I EXPECT?
              .body-1 We gather together as a family every Sunday so we can be equipped to scatter together across our community during the week. Our Sunday focus is on corporate worship, scriptural teaching and fellowship. 
            div.mb-4.faqText
              .title WHEN DOES SUNDAY SERVICE START?
              .body-1 Our services begin at 11:00 am. There is an Intercessory Prayer time before the service at 10:30am. Our service runs for as long as the Holy Spirit directs. We invite you to be on time at 11am, but if you work on Sundays or have other obligations, come as soon as you are able. 
            div.mb-4.faqText
              .title WHAT DO I DO WHEN I ARRIVE?
              .body-1 We encourage you to come early to let our ushers help you find a seat. We hope you fill out the Welcome Card; this allows someone from our church family to follow up with you and help you take your next step. Hand the card to one of our ushers or place it in the offering basket.
            div.mb-4.faqText
              .title WHAT IS WORSHIP LIKE?
              .body-1 Through our worship arts teams, you’ll experience an amazing time of worship directed to God alone. We mix contemporary worship songs with upbeat traditional songs of faith to achieve a great balance of worship styles. Our worship time is carefully planned to prepare hearts and minds to receive what God will say through the preaching of the Word.
            div.mb-4.faqText
              .title WHAT SHOULD I WEAR?
              .body-1 At City of Refuge UCC we encourage you to come as you are. Most people come dressed comfortably in ways that express their authentic selves; some wear suits, ties and dresses and many wear jeans or pants. God sees our heart and that’s what we care about too.
            div.mb-4.faqText
              .title WHERE DO I PARK?
              .body-1 We have a large parking lot on campus behind our church building.
            div.mb-4.faqText
              .title WHO IS WELCOME?
              .body-1 If you are not a Christian or believer in God, you are welcome.
        v-row(justify="center")
          v-col(cols="12")
            v-card.pa-4(color="info",dark)
              p.display-1() 
                a.no-anchor-decoration(href="/visit/contact")
                  u Contact Us Directly
</template>

<script>
import { getSunday } from '../../plugins/getDays';
import gMap from '../footer/googleMap';
export default {
  components: {
    gMap
  },
  created() {
    this.getSunday = getSunday();
  }
};
</script>

<style lang="stylus" scoped>
.serviceTime
  color var(--v-primary-base)

.faqText
  color white

  .title
    color var(--v-info-lighten3)
</style>
